<template>
  <div class="pages-salesccenter">
    <!-- <div> -->
    <iframe
      v-if="iframeUrl"
      id="iframe-salescenter"
      ref="iframe"
      :src="iframeUrl"
      height="100%"
      frameborder="no"
      border="0"
      marginwidth="0"
      marginheight="0"
      scrolling="no"
    />
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { getAdminUrl } from '@/api/auth'
export default {
  data () {
    const token = this.$store.getters.token
    const Url = this.$store.getters.userInfo.adminUrl
    return {
      windowWidth: 0,
      windowHeight: 0,
      iframeUrl: `${Url}/?token=${token}`,
      // iframeUrl: `http://localhost:3000?token=${token}`,
      frameLoadFlag: false
      // iframeUrl:`${process.env.VUE_APP_SHOP_IFRAME}?token=${token}`
    }
  },
  async created () {
    this.loading = this.$loading({
      lock: true,
      text: '正在加载销售中心......',
      spinner: 'el-icon-loading'
    })
    window.addEventListener('message', (event) => {
      var data = event.data
      if (data.cmd == 'getToken') {
        console.log(`recive token from sub main: ${data.params.token}`)
        this.setToken(data.params.token)
        if (this.$store.getters.token != data.params.token) {
          this.iframeUrl = `${process.env.VUE_APP_SHOP_IFRAME}/?token=${data.params.token}`
          //  this.iframeUrl = `http://localhost:3000?token=${data.params.token}`
        }
        // setTimeout(() => {
        //   window.location.reload()
        // }, 1000)
      } else if (data.cmd == 'notExistAuth') {
        this.$router.push('/')
      }
    })
  },
  mounted () {
    this.onLoadIframe()
  },
  destroyed () {
    this.loading.close()
  },
  methods: {
    ...mapActions(['setToken']),
    onLoadIframe () {
      this.windowHeight = document.documentElement.clientHeight - 54
      const iframe = document.querySelector('#iframe-salescenter')
      iframe.onload = () => {
        console.log('iframe已加载完毕')
        this.frameLoadFlag = true
        // this.postMessage()
        this.loading.close()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.pages-salesccenter {
  height: 100%;
  iframe {
    width: 100%;
    height: 100%;
  }
}
</style>
